import React from 'react'
import UserProfilePage from "../Components/userprofile/userprofile";
function userprofile() {
    return (
        <UserProfilePage />
      )
}

export default userprofile
